// Export Workflow — the static EEI $2,500 value-exemption note (scope-selection plan Slice 4).
// The workflow no longer ASKS the shipment-value question; the EEI determination renders its
// conditional form instead, and this note explains the threshold on the Product Profile result
// (live card, Saved Work, PDF). Pure TS so the PDF builder can share it.

export const EEI_VALUE_EXEMPTION_NOTE =
  'EEI/AES filing is generally required over $2,500 per Schedule B number; $2,500-or-less is ' +
  'exempt when no license is required (15 CFR §30.37(a)).';

/**
 * Show the note only when the EEI check ran AND the value exemption is relevant. pyapi
 * eei_rules.determine_eei leaves `value_exemption` = "Not applicable" on the jurisdiction-
 * independent exclusions (intangible transfer, domestic / territory, Canada), where a $2,500
 * threshold would only confuse. Self-hides on scoped reviews (no profile → no determination).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function showEeiValueExemptionNote(eei: any): boolean {
  const exemption = String(eei?.value_exemption || '').trim();
  return Boolean(eei?.filing_determination) && Boolean(exemption) && !/^not applicable/i.test(exemption);
}
